import type { ButtonHTMLAttributes, ReactNode } from 'react'

type Variant = 'default' | 'primary' | 'subtle' | 'danger'
type Size = 'sm' | 'md'

interface Props extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  children: ReactNode
  variant?: Variant
  size?: Size
  busy?: boolean
}

export function Button({ children, variant = 'default', size = 'md', busy, className, disabled, ...rest }: Props) {
  const classes = ['btn', variant !== 'default' ? variant : '', size === 'sm' ? 'sm' : '', className ?? '']
    .filter(Boolean).join(' ')
  return (
    <button
      type="button"
      className={classes}
      disabled={disabled || busy}
      aria-busy={busy ? true : undefined}
      {...rest}
    >
      {busy ? <span className="spinner" aria-hidden="true" /> : null}
      {children}
    </button>
  )
}
